import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import React from 'react'

export function RentabilityDialog({ open, handleCloseDialog }) {
	return (<Dialog
	open={open}
	onClose={handleCloseDialog}
	aria-labelledby="alert-dialog-title"
	aria-describedby="alert-dialog-description"
	>
		<DialogContent>
			<DialogContentText id="alert-dialog-description">
				Chamamos de rentabilidade real o valor final de um investimento após ser descontada a inflação acumulada no período. A rentabilidade nominal é o valor bruto, sem considerar a perda de valor do dinheiro no período.
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={handleCloseDialog} color="primary">
				Ok
			</Button>
		</DialogActions>
	</Dialog>)
}
